export interface WarningSession {
  key: string;
  account: string;
}

/** Token refresh preserves a session; every logout/account transition invalidates callbacks immediately. */
export function createQualityWarningSession() {
  let current: WarningSession | undefined;
  let sequence = 0;
  const presented = new Set<string>();
  return {
    update(account: string | undefined) {
      if (current?.account !== account) {
        current = account ? { account, key: `${account}:${++sequence}` } : undefined;
        presented.clear();
      }
      return current;
    },
    isCurrent(session: WarningSession | undefined) { return !!session && session === current; },
    wasPresented(id: string) { return presented.has(id); },
    present(id: string) { presented.add(id); },
  };
}
